import styled from 'styled-components';

import { ContentBanner } from '@xingternal/banner';
import { Divider } from '@xingternal/divider';
import { mediaSmallOrTiny } from '@xingternal/layout-tokens';
import { space3XL, spaceXL } from '@xingternal/tokens';
import { Row } from '@xingternal/xing-grid';

export const StyledContentBanner = styled(ContentBanner)`
  padding: ${spaceXL};
  width: 100%;
  flex-direction: column;
  align-items: stretch;
`;

export const StyledBenefitsSection = styled.div`
  width: 100%;
`;

export const StyledDivider = styled(Divider)`
  width: 90%;
  margin-top: ${space3XL};

  @media ${mediaSmallOrTiny} {
    display: none;
  }
`;

export const StyledCultureSection = styled(Row)`
  margin-top: ${space3XL};
`;

export const FullWidthRating = styled.div`
  width: 100%;
`;
